import { Inject, Injectable, InjectionToken, Input, Output, Type, Directive, Self, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpProgressEvent, HttpEventType, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import {Observable, throwError, of, BehaviorSubject,  Subscriber, Observer, Subject} from 'rxjs';
import { map,catchError, retry, take, debounceTime,  tap } from 'rxjs/operators';
import { action } from '../interfaces/action';
import { UserAuthentication } from '../interfaces/user-authentication';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { CryptoServices } from './CryptoServices';
import { finalize } from 'rxjs/operators';


const httpOptions = {
  headers: new HttpHeaders({
    Authorization: 'my-auth-token'
  }),
  
  reportProgress: true, 
  responseType: 'json' as 'json'
};


class PagedData<T> {
  data: T[];
}


@Injectable({
  providedIn: 'any'
})
export class HTTPService {
  
  apiRoot:string = environment.endpoint;
  results:Object[];
  loading:Boolean;

  readonly event: Observable<Event>;
  public httpEvent:Event;
  public _observer: Observer<Event>;
  @Output('onSearch') onSearch = new EventEmitter();
  public progress:Subject<number> = new Subject()
  user:UserAuthentication = null;

  
  constructor(private httpCliente:HttpClient, private router:Router, private crypto:CryptoServices) { 
    this.loading = false;
    this.event = new Observable<Event>(observer => this._observer = observer);  
  }

  createHeader(authentication){

    if ( authentication){
      if ( localStorage.getItem('user')){
        
        this.user = JSON.parse(localStorage.getItem('user'));
        httpOptions.headers = httpOptions.headers.set('Authorization', this.user.token );
        //httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json; charset=ISO-8859-1');
        
      }else{
          throw ("Não existe autenticação no servidor de aplicação.");
      }
    }
    
  }


  createHeader2(authentication){

    if ( authentication){
      if ( localStorage.getItem('user')){
        
        this.user = JSON.parse(localStorage.getItem('user'));
        httpOptions.headers = httpOptions.headers.set('Authorization', this.user.token );
        httpOptions.reportProgress = true;
        //httpOptions['observe']='events';
        
        
      }else{
          throw ("Não existe autenticação no servidor de aplicação.");
      }
    }
    
  }

  
  public handleError(error, throwError:Boolean = true) {
    this.httpEvent = new Event("stopPost");
    
    if(this._observer){      
      this._observer.next(this.httpEvent);   
    }

    if ( throwError ){
      throw error;
    }
    
    
  };


  public executeBackEndAction(instanceName:string, action: action, rows:object[], parameters, retry:Boolean = false) {
    
    let ob = {
      "entityName":instanceName,
      "rows":rows,
      "action":action,
    }

    if ( retry ){
      ob["CHOOSE"] = true;
    }

    
    if (parameters && parameters != null){
      // ✅ Verifica se é string antes de fazer parse
      ob["parameters"] = typeof parameters === 'string' ? JSON.parse(parameters) : parameters;
    }

    return this.post(ob,"JsonBrokerServices/action",true);
    
  }

  public getAsset( location:string ){
      return this.httpCliente.get(location,{responseType: 'text'} );
  }

  public getAsset2( location:string){
    return this.httpCliente.get(location );
  }


  public get( url:string, header:Record<string,string> = null){
    if ( header != null ){
      let httpHeaders = new HttpHeaders(header);
      return this.httpCliente.get(url,{headers:httpHeaders});
    }
    return this.httpCliente.get(url,{headers:header});
  }

  


  public post( body:any, service:String, showEstructure:Boolean, authentication:Boolean = true, encrypt:Boolean = true, loadEvent:Boolean = true) {
    
    if( loadEvent ){
      this.httpEvent = new Event("startPost");

      if ( this._observer != undefined){
        this._observer.next(this.httpEvent);    
      }
    }
    
    this.createHeader(authentication);
    

    if ( encrypt  && environment.enableCrypto){
        let value:string = this.crypto.encrypt(body);
        body = { value: value};
    }
    
    if ( showEstructure ){  
      //console.log(`Url: ${this.apiRoot+service},`+
        //          `Body: ${JSON.stringify(body)} `);
    }
    
    return this.httpCliente.post(this.apiRoot+service,body,httpOptions).pipe(
      finalize(()=>{
        // Emite "stopPost" SEMPRE que a request termina (sucesso, erro OU cancelamento).
        // Antes o stopPost saia so no sucesso: estava no 2o argumento do map(), que o
        // RxJS IGNORA. Resultado: qualquer request com erro deixava a barra de loading
        // global travada infinitamente. Com finalize o start/stop fica 1:1.
        if( loadEvent ){
          this.httpEvent = new Event("stopPost");
          if ( this._observer != undefined){
            this._observer.next(this.httpEvent);
          }
        }
      })
    );
    
      
  }


  getEventSource(service: string,body: any): Observable<{ event: string, data: string }> {
    return new Observable(observer => {

      const token = this.user.token;
      const params = new URLSearchParams(body).toString();
      const url = `${this.apiRoot}${service}?authtoken=${encodeURIComponent(token.replace("Bearer ",""))}&${params}`;
      const eventSource = new EventSource(url);

      eventSource.addEventListener("token", (event: any) => {
        observer.next({ event: "token", data: event.data });
      });

      eventSource.addEventListener("finish", (event: any) => {
        const json = JSON.parse(event.data);
        observer.next({ event: "finish", data: json });
        observer.complete();
        eventSource.close();
      });

      eventSource.onerror = err => {
        observer.error(err);
        eventSource.close();
      };

      return () => eventSource.close();
    });        
  }


  async postStream(service: string,body: any,onChunk: (chunk: string) => void,encrypt: boolean = true): Promise<void> {



      // criptografia opcional
      if (encrypt && environment.enableCrypto) {
        const value = this.crypto.encrypt(body);
        body = { value };
      }

      this.user = JSON.parse(localStorage.getItem('user'));

      const response = await fetch(this.apiRoot + service, {
        method: "POST",
        headers: {
           'Content-Type': 'application/json',
           'Authorization':this.user.token 
        },
        body: JSON.stringify(body)
      });

      const reader = response.body!.getReader();
      const decoder = new TextDecoder();

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        onChunk(chunk);
      }
  }



  public post2( body:any,url:string, header:Record<string,string> = null, loadEvent:Boolean = true) {
    
    if( loadEvent ){
      this.httpEvent = new Event("startPost");

      if ( this._observer != undefined){
        this._observer.next(this.httpEvent);    
      }
    }
    
    if ( header != null ){
      let httpHeaders = new HttpHeaders(header);
      httpOptions.headers = httpHeaders;
    }
    
    
    return this.httpCliente.post(url,body,httpOptions).pipe(map(res=>{
          
          if( loadEvent ){
            this.httpEvent = new Event("stopPost");
            
            if ( this._observer != undefined){
              this._observer.next(this.httpEvent);    
            }
          }
          return res;
        
    },error=>{
        this.handleError(error);
    }));
    
      
  }

  
 

  public downloadFile( service:string, authentication:boolean = true, text:boolean = false){

      
      this.httpEvent = new Event("startPost");
      this._observer.next(this.httpEvent);    

      this.createHeader(authentication);

      if(text){
        httpOptions.responseType = 'text' as 'json';
      }else{
        httpOptions.responseType = 'blob' as 'json';
      }

      

      return this.httpCliente.get(this.apiRoot + service, httpOptions)
        .pipe(
            finalize(() => {
                this.httpEvent = new Event("stopPost");
                this._observer.next(this.httpEvent);
            })
        );

    
    
  }

  public postFile( body:any, service:String, showEstructure:Boolean, authentication:Boolean = true, ignoreerror:Boolean =false) : Observable<any> {
    
    
    this.httpEvent = new Event("startPost");

    if ( this._observer != undefined){
      this._observer.next(this.httpEvent);
    }
    
    
    this.progress.next(0);
    this.createHeader2(authentication);

    const req = new HttpRequest('POST', this.apiRoot + service, body, httpOptions);
    return this.httpCliente.request(req).pipe(
      map(event => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            // Compute and return the progress
            event.loaded
            event.total
            const progress = Math.round(100 * event.loaded / event.total);
            
            this.progress.next(progress);
            return { status: 'progress', message: progress };
          case HttpEventType.Response:
            
           const responseBody = (event as HttpResponse<any>).body;
            if(responseBody){
              this.httpEvent = new Event("stopPost");
              if(this._observer){
                this._observer.next(this.httpEvent);
                this._observer.complete(); //notifica que completou.
              }              
            }

            return event.body;
          default:
            // Return nothing in all other cases
            return `Unhandled event: ${event.type}`;
        }
      }),
      catchError(error => {
        if (!ignoreerror) {
          this.handleError(error)
        }
        // Emit the error to the caller
        return throwError(error);
      })
    );
  }

  public postGeneric<T>( body:any, service:String, showEstructure:Boolean, authentication:Boolean = true, encrypt:Boolean = true, loadEvent:Boolean =true ) {
    

    if( loadEvent ){
    
      this.httpEvent = new Event("startPost");

      if ( this._observer != undefined){
        this._observer.next(this.httpEvent);    
      }
    }

    this.createHeader(authentication);
    
    if ( showEstructure ){
      //console.log(`Url: ${this.apiRoot+service},`+
        //          `Body: ${JSON.stringify(body)} `);
    }
    return this.httpCliente.post<T>(this.apiRoot+service,body,httpOptions).pipe(tap(res=>{
          if ( loadEvent ){
            this.httpEvent = new Event("stopPost");
            this._observer.next(this.httpEvent);
          }
      },error=>{
        this.handleError(error)
      }));    
  }
  
  public postLazy( body:any, service:String, showEstructure:Boolean, time:number, authentication:Boolean = true, encrypt:Boolean = true )  {
    /// precisa arrumar se for usar///
    
    
    if ( showEstructure ){
      //console.log(`Url: ${this.apiRoot+service},`+
        //          `Body: ${JSON.stringify(body)} `);
    }
    return this.httpCliente.post(this.apiRoot+service,body,{
      headers:null
      }).pipe(debounceTime(time), tap(res=>{
          this.httpEvent = new Event("stopPost");
          
          this._observer.next(this.httpEvent);  
      }));
      
  }


  stopSubscription(){
    this.httpEvent = new Event("stopPost");
    if(this._observer){      
      this._observer.next(this.httpEvent);  
    }
  }
}